module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clock-container"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/clock.png",
      "alt": "clock",
      "width": "47",
      "height": "47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-container"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Tiempo:")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm._f("formatTime")(_vm.minute)) + ":" + _vm._s(_vm._f("formatTime")(_vm.second)) + "\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20aa2ce3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Clock.vue
// module id = 1177
// module chunks = 33 34 38